export const toastMixin = {
  methods: {
    // User can send argument as different different argument or just one single object containing all details
    showToast(toastDetails, type, ctaCallback, duration) {
      if (typeof toastDetails === "object") {
        this.$root.$emit("showToast", toastDetails)
      } else {
        this.$root.$emit("showToast", {
          message: toastDetails,
          type,
          ctaCallback,
          duration,
        })
      }
    },
  },
}
